define('services/viewport',[
    'jquery'
], function($) {

    // cached elements
    var $window = $(window),
        cachedWindow = {
            width: $window.width(),
            height: $window.height()
        };

    /**
     * Caching the window width to prevent layout thrashing
     * when calling ".width()".
     */
    $window.resize(function(e) {
        var currentTarget = e.currentTarget;
        cachedWindow.width = currentTarget.innerWidth;
        cachedWindow.height = currentTarget.innerHeight;
    });

    /**
     * Helper object related to mobile and viewport functions.
     * @type {Object}
     */
    var Viewport = {
        isMobile: function() {
            // return $window.width() < 768;
            return cachedWindow.width < 768;
        },
        height: function() {
            return cachedWindow.height;
        },
        width: function() {
            return cachedWindow.width;
        },
    };

    return Viewport;

});

